import { Page, Text, View, Image, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#E4E4E4',
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    flexGrow: 1,
    flex: 1,
  },
  logo: {
    width: 100,
    height: 50,
    marginRight: 10,
  },
  separator: {
    borderBottomWidth: 1,
    borderBottomColor: 'black',
    marginVertical: 10,
    width: '100%',
  },
  section: {
    borderWidth: 1,
    borderColor: '#000',
    padding: 1,
    marginBottom: 10,
  },
  table: {
    display: 'table',
    width: 'auto',
    alignSelf: 'center',
  },
  tableRow: {
    flexDirection: 'row',
    fontSize: 12,
  },
  tableCell: {
    padding: 5,
    fontSize: 12,
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCellHeader: {
    padding: 5,
    fontSize: 12,
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },
  firstTableCell: {
    padding: 5,
    fontSize: 12,
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },
  firstTableCellHeader: {
    padding: 5,
    fontSize: 12,
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  }
});

const PDFDocument = ({ data, canvasUrl }) => {
  const renderTable = (tableData) => {
    return (
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <Text style={styles.firstTableCellHeader}>Account</Text>
          <Text style={styles.tableCellHeader}>Starting Balance</Text>
          <Text style={styles.tableCellHeader}>Ending Balance</Text>
          <Text style={styles.tableCellHeader}>Transactions</Text>
        </View>
        {tableData.map((row, index) => (
          <View key={index} style={styles.tableRow}>
            <Text style={styles.firstTableCell}>{row.account}</Text>
            <Text style={styles.tableCell}>$ {row.starting_balance.toFixed(2)}</Text>
            <Text style={styles.tableCell}>$ {row.ending_balance.toFixed(2)}</Text>
            <Text style={styles.tableCell}>$ {row.transactions.toFixed(2)}</Text>
          </View>
        ))}
      </View>
    );
  };

  return (
    data && (
      <Document title={data.title}>
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <Image src="/assets/img/arpari-logos/Logo-Arpari-navy.png" style={styles.logo} />
            <Text style={styles.title}>{data.title}</Text>
          </View>
          <View style={styles.separator} />

          {/* Cash Balance Trends section */}
          <Text style={{ marginBottom: 5 }}>
            Cash Balance Trends
          </Text>

          <View style={styles.separator} />
          <View style={{ ...styles.view, marginBottom: 5 }}>
            {canvasUrl && <Image style={styles.chartImage} src={canvasUrl} />}
          </View>

          <View style={styles.separator} />

          {/* Accounts section */}
          <Text style={{ marginBottom: 5 }}>
            Accounts
          </Text>

          <View style={styles.separator} />
          {renderTable(data.tableData)}
        </Page>
      </Document>
    )
  );
};

export default PDFDocument;
